import Worker from "./file.worker.js";
import * as Comlink from "comlink";
const bindAll = require('lodash.bindall');
const WorkerClass = Comlink.wrap(new Worker());

class WEBcam{
    constructor(parent){
        bindAll(this,["enableCamera","disableCamera","getFrame","sendFrame"]);
        this._parent = parent;
        this.stream = null;
    }
    enableCamera(){
        try{
            navigator.mediaDevices.getUserMedia({video: {width: 426, height: 240}}).then((stream) => {this.stream= stream;document.querySelector('video').srcObject = stream});
            document.querySelector('video').play();
            this._parent.props.disableCamera();
            this._parent.webSocketClient.ws.send(JSON.stringify({type:"CAMERA_ENABLED"}));
            WorkerClass.sendFrames(Comlink.proxy(this.sendFrame));
        }
        catch(err)
        {
            this._parent.webSocketClient.ws.send(JSON.stringify({type:"CAMERA_DISABLED"}));
            console.log(err);
        }
    }
    sendFrame(){
        console.log("sending Frames");
        if(this._parent.webSocketClient.ws.readyState!=1)
                return this.disableCamera();
        this._parent.webSocketClient.ws.send(JSON.stringify({type:"SEND_FRAMES_TO_PICTOBLOX",data:this.getFrame()}));
    
    }
    disableCamera(){
        try{
            this.stream.getTracks().forEach(function(track){
                track.stop();
            })
            document.querySelector('video').srcObject=null;
            WorkerClass.stopFrames();
            this._parent.webSocketClient.ws.send(JSON.stringify({type:"CAMERA_DISABLED"}));
            this._parent.props.enableCamera();
            clearInterval(this.frameInterval);
        }
        catch(err)
        {
            console.log("Error in closing stream")
        }
    }
    getFrame(){
        var video = document.querySelector('video');
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);
        const data = canvas.toDataURL('image/png');
        return data;
    }
}

export default WEBcam;